/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';
import styled from 'styled-components';

const EditorContainer = styled.div`
  .jsoneditor {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  .jsoneditor-menu {
    background-color: #1890ff;
    border-bottom: 1px solid #096dd9;
  }
`;

function JsonEditor({ value, onChange, height = 400 }) {
    const containerRef = useRef(null);
    const editorRef = useRef(null);

    useEffect(() => {
        if (containerRef.current && !editorRef.current) {
            const options = {
                mode: 'code',
                modes: ['code', 'tree', 'view'],
                language: 'ru',
                languages: {
                    ru: {
                        array: 'Массив',
                        auto: 'Авто',
                        appendText: 'Добавить',
                        appendTitle: 'Добавить новое поле с типом "auto" после этого поля',
                        appendSubmenuTitle: 'Выберите тип поля для добавления',
                        appendTitleAuto: 'Добавить новое поле с типом "auto"',
                        ascending: 'По возрастанию',
                        ascendingTitle: 'Сортировать дочерние элементы этого поля по возрастанию',
                        actionsMenu: 'Нажмите для открытия меню действий',
                        collapseAll: 'Свернуть все поля',
                        descending: 'По убыванию',
                        descendingTitle: 'Сортировать дочерние элементы этого поля по убыванию',
                        drag: 'Перетащите для перемещения этого поля',
                        duplicateKey: 'дублирующийся ключ',
                        duplicateText: 'Дублировать',
                        duplicateTitle: 'Дублировать выбранные поля',
                        duplicateField: 'Дублировать это поле',
                        duplicateFieldError: 'Дублирующееся имя поля',
                        cannotParseFieldError: 'Невозможно разобрать поле в JSON',
                        cannotParseValueError: 'Невозможно разобрать значение в JSON',
                        empty: 'пусто',
                        expandAll: 'Развернуть все поля',
                        expandTitle: 'Нажмите для развертывания/свертывания этого поля. Ctrl+Click для развертывания/свертывания включая все дочерние элементы.',
                        insert: 'Вставить',
                        insertTitle: 'Вставить новое поле с типом "auto" перед этим полем',
                        insertSub: 'Выберите тип поля для вставки',
                        object: 'Объект',
                        ok: 'ОК',
                        redo: 'Повторить',
                        redoTitle: 'Повторить последнее отмененное действие',
                        removeText: 'Удалить',
                        removeTitle: 'Удалить выбранные поля',
                        removeField: 'Удалить это поле',
                        selectNode: 'Выбрать узел...',
                        showAll: 'показать все',
                        showMore: 'показать больше',
                        showMoreStatus: 'отображается ${visibleChilds} из ${totalChilds} элементов.',
                        sort: 'Сортировать',
                        sortTitle: 'Сортировать дочерние элементы этого поля',
                        sortTitleShort: 'Сортировать содержимое',
                        sortFieldLabel: 'Поле:',
                        sortDirectionLabel: 'Направление:',
                        sortFieldTitle: 'Выберите вложенное поле для сортировки массива или объекта',
                        sortAscending: 'По возрастанию',
                        sortAscendingTitle: 'Сортировать выбранное поле по возрастанию',
                        sortDescending: 'По убыванию',
                        sortDescendingTitle: 'Сортировать выбранное поле по убыванию',
                        string: 'Строка',
                        transform: 'Преобразовать',
                        transformTitle: 'Фильтровать, сортировать или преобразовывать дочерние элементы этого поля',
                        transformTitleShort: 'Фильтровать, сортировать или преобразовывать содержимое',
                        extract: 'Извлечь',
                        extractTitle: 'Извлечь это поле',
                        type: 'Тип',
                        typeTitle: 'Изменить тип этого поля',
                        openUrl: 'Ctrl+Click или Ctrl+Enter для открытия URL в новом окне',
                        undo: 'Отменить',
                        undoTitle: 'Отменить последнее действие',
                        validationCannotMove: 'Невозможно переместить поле в одно из его дочерних полей',
                        autoType: 'Поле типа "auto". Тип поля автоматически определяется из значения и может быть строкой, числом, логическим значением или null.',
                        objectType: 'Поле типа "object". Объект содержит неупорядоченный набор пар ключ/значение.',
                        arrayType: 'Поле типа "array". Массив содержит упорядоченную коллекцию значений.',
                        stringType: 'Поле типа "string". Поле не разбирается как JSON.',
                        modeCodeText: 'Код',
                        modeCodeTitle: 'Переключиться в режим подсветки кода',
                        modeFormText: 'Форма',
                        modeFormTitle: 'Переключиться в режим редактора форм',
                        modeTextText: 'Текст',
                        modeTextTitle: 'Переключиться в режим простого текста',
                        modeTreeText: 'Дерево',
                        modeTreeTitle: 'Переключиться в режим редактора дерева',
                        modeViewText: 'Просмотр',
                        modeViewTitle: 'Переключиться в режим просмотра',
                        modePreviewText: 'Предпросмотр',
                        modePreviewTitle: 'Переключиться в режим предпросмотра',
                        examples: 'Примеры',
                        default: 'По умолчанию',
                    },
                },
                onChange: () => {
                    try {
                        const json = editorRef.current.get();
                        onChange(json);
                    } catch (e) {
                        // Invalid JSON, ignore
                    }
                },
                onValidationError: () => {
                    // Handle validation errors if needed
                },
            };

            editorRef.current = new JSONEditor(containerRef.current, options);

            try {
                editorRef.current.set(value || {});
            } catch (e) {
                editorRef.current.set({});
            }
        }

        return () => {
            if (editorRef.current) {
                editorRef.current.destroy();
                editorRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (editorRef.current && value) {
            try {
                const currentValue = editorRef.current.get();
                if (JSON.stringify(currentValue) !== JSON.stringify(value)) {
                    editorRef.current.set(value);
                }
            } catch (e) {
                // Ignore errors
            }
        }
    }, [value]);

    return (
        <EditorContainer>
            <div ref={containerRef} style={{ height: `${height}px` }} />
        </EditorContainer>
    );
}

export default JsonEditor;
